import { onMounted, onUnmounted } from 'vue'

export function useEscapeKey(callback: () => void, isEnabled: boolean = true) {
    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && isEnabled) {
            callback()
        }
    }

    onMounted(() => {
        document.addEventListener('keydown', handleKeyDown)
    })

    onUnmounted(() => {
        document.removeEventListener('keydown', handleKeyDown)
    })
}